import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import * as api from "@nens/threedi/openapi-client";

import { getV3Api } from "../../apiConfiguration";
import Duration from "../../components/Duration";
import { findDesignRain } from "../../data/designedRainsData";
import { getExistingTimeseriesRain } from "../../state/existingEvents";
import { menuExistingItemCardRow } from "../../styles/styleComposition";
import { simulationIdFromUrl } from "../../utils/apiUtils";
import menuExistingItemStyles from "../MenuExistingItemStyles.module.css";

import ExistingItemCard from "./ExistingItemCard";

const ExistingDesignRainEvent: React.FC<{
  rainEvent: api.TimeseriesRain;
}> = ({ rainEvent }) => {
  const onDelete = useCallback(async () => {
    const v3Api = getV3Api();
    if (rainEvent && rainEvent.id && rainEvent.simulation) {
      try {
        await v3Api.simulationsEventsRainTimeseriesDelete({
          id: rainEvent.id,
          simulationPk: simulationIdFromUrl(rainEvent.simulation),
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [rainEvent]);

  const [designRainKey, designRain] = findDesignRain(rainEvent.values);

  // Note that design rain *cannot be stopped*, or it wouldn't be that design shower

  return (
    <ExistingItemCard
      onDelete={onDelete}
      start={rainEvent.offset}
      end={rainEvent.duration ? rainEvent.offset + rainEvent.duration : undefined}
      controlType="editRain"
    >
      <div className={menuExistingItemCardRow}>
        <span>Type:</span>
        <span className={menuExistingItemStyles.ItemName}>
          Design {designRainKey !== null ? `type ${designRainKey} ` : null}{" "}
          {designRain !== null && designRain.onceInAmountOfYears
            ? `(t=${designRain.onceInAmountOfYears}y)`
            : null}
        </span>
      </div>
      {rainEvent.duration ? (
        <div className={menuExistingItemCardRow}>
          <span>
            <FormattedMessage id="newRainMenu.duration_label" defaultMessage="Duration" />:
          </span>
          <span>
            <Duration duration={rainEvent.duration} />
          </span>
        </div>
      ) : null}
    </ExistingItemCard>
  );
};

const ExistingTimeseriesRain = () => {
  const existingTimeseriesRainEvents = useSelector(getExistingTimeseriesRain);

  return (
    <div>
      {existingTimeseriesRainEvents.map((rainEvent) => {
        // check for active status of the rain event
        return <ExistingDesignRainEvent rainEvent={rainEvent} key={rainEvent.url} />;
      })}
    </div>
  );
};

export default ExistingTimeseriesRain;
